
<script>
	import VehicleAlarm from 'components/pages/didivehiclemonitor/menumaptabs/VehicleAlarm'
	import FenceList from 'components/pages/didivehiclemonitor/menumaptabs/FenceList'
	import RoutesList from 'components/pages/didivehiclemonitor/menumaptabs/RoutesList'
	import MarkersList from 'components/pages/didivehiclemonitor/menumaptabs/MarkersList'
	import RoutePlanDetail from 'components/pages/didivehiclemonitor/menumaptabs/RoutePlanDetail'
	import DeviceInstructions from 'components/pages/didivehiclemonitor/menumaptabs/DeviceInstructions'
	import VehicleDetail from 'components/pages/didivehiclemonitor/menumaptabs/VehicleDetail'
	import {mapState} from 'vuex'
	export default {
		name: 'NewPanelBox',
		components:{
			VehicleAlarm,
			FenceList,
			RoutesList,
			MarkersList,
			RoutePlanDetail,
			DeviceInstructions,
			VehicleDetail
		},
		computed:{
			...mapState({
				mapTabList:state=>state.monitor.mapTabList,
				mapIndex:state=>state.monitor.mapIndex
			})
		},
		render:function(h){	
			const mapTabList = this.mapTabList;
 			const mapIndex = this.mapIndex;
	 		let children = [];
	 		function addFollowPanel(){
	 			for(let i=0,length = mapTabList.length; i < length; i++){
		 			if(mapTabList[i].No === mapIndex){
		 				children.push(h(mapTabList[i].id,{style:{display:'block'}}))
		 			}else{
		 				children.push(h(mapTabList[i].id,{style:{display:'none'}}))
		 			}
	 			}
	 			return children;
	 		}	
	  		return h('div',addFollowPanel())
	  		
  		}
	};
</script>
	



// WEBPACK FOOTER //
// NewPanelBox.vue?a460929c